import { render, staticRenderFns } from "./kdSolutionAudit.vue?vue&type=template&id=506fcddb&scoped=true"
import script from "./kdSolutionAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdSolutionAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fcddb",
  null
  
)

export default component.exports